import { Component, input, ViewEncapsulation } from '@angular/core';

export type RaChatSender = 'user' | 'assistant';

/**
 * Uma fala do chat, na coluna de leitura (máx. 720px, centrada):
 * - `user`: cartão branco com sombra sutil, à direita;
 * - `assistant`: texto FLAT sobre o fundo, sem bolha (estilo Claude).
 *
 * O conteúdo é projetado. Encapsulamento None (classes prefixadas com `ra-chat-bubble`)
 * de propósito: os estilos de base do texto, imagem e vídeo precisam alcançar o conteúdo
 * que o chamador projeta.
 */
@Component({
    selector: 'ra-chat-bubble',
    template: `<article class="ra-chat-bubble" [class.ra-chat-bubble--user]="sender() === 'user'"><ng-content /></article>`,
    styleUrl: 'ra-chat-bubble.component.scss',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'ra-chat-bubble-row',
        '[class.ra-chat-bubble-row--user]': "sender() === 'user'",
    },
})
export class RaChatBubbleComponent {
    public sender = input<RaChatSender>('assistant');
}
